module.exports = __webpack_public_path__ + "public/img/sos.d726237d.png";